// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"bf35ec56","512":"62f0fb0d","524":"bf35ec56","823":"bf35ec56"}[chunkId] + ".chunk.css";
};